import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bccdae3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "grid pulse-email-section w-full h-full",
  id: "email-section",
  ref: "box"
}
const _hoisted_2 = {
  id: "header",
  class: "border-bottom py-3"
}
const _hoisted_3 = { class: "overflow-auto" }
const _hoisted_4 = { id: "replyArea" }
const _hoisted_5 = { class: "text-secondary" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Click here to reply from ")
const _hoisted_7 = { class: "custom-control custom-switch" }
const _hoisted_8 = { class: "text-right mr-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Replying from ")
const _hoisted_10 = { class: "flex items-center justify-between p-2" }
const _hoisted_11 = { class: "inline-flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "isClient"
}, " Internal only? ", -1))
const _hoisted_13 = {
  key: 0,
  enctype: "multipart/form-data",
  novalidate: ""
}
const _hoisted_14 = { class: "dropbox" }
const _hoisted_15 = ["name", "disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { id: "forwardArea" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "to" }, "To:", -1))
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "from" }, "From:", -1))
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "subject" }, "Subject:", -1))
const _hoisted_27 = { class: "custom-control custom-switch d-inline-block mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "isClient"
}, " Internal only? ", -1))
const _hoisted_29 = { class: "mt-3" }
const _hoisted_30 = {
  key: 0,
  enctype: "multipart/form-data",
  novalidate: ""
}
const _hoisted_31 = { class: "dropbox" }
const _hoisted_32 = ["name", "disabled"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { class: "overflow-auto" }
const _hoisted_38 = { class: "py-2" }
const _hoisted_39 = { class: "col text-right" }
const _hoisted_40 = {
  key: 0,
  class: "font-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailHeader = _resolveComponent("EmailHeader")!
  const _component_EmailBody = _resolveComponent("EmailBody")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.email.from)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_component_EmailHeader, {
                from: _ctx.email.from,
                to: _ctx.email.to == null ? null : _ctx.email.to[0],
                dateCreated: _ctx.email.dateCreated,
                emailId: _ctx.email.id,
                isProtected: _ctx.email.folder?.protected,
                currentPage: _ctx.currentPage,
                onScrollToReply: _ctx.startReply,
                onScrollToForward: _ctx.startForward,
                onSearchEmail: _ctx.searchEmail,
                folderId: _ctx.email.folderId
              }, null, 8, ["from", "to", "dateCreated", "emailId", "isProtected", "currentPage", "onScrollToReply", "onScrollToForward", "onSearchEmail", "folderId"])
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_EmailBody, {
              subject: _ctx.email.subject,
              body: _ctx.email.body,
              attachments: _ctx.email.attachments
            }, null, 8, ["subject", "body", "attachments"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            (!_ctx.replying)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "reply-box bg-gray p-3 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startReply && _ctx.startReply(...args)))
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("b", null, _toDisplayString(_ctx.email.replyFromAddress ?? _ctx.email.to ? _ctx.email.to![0] : ""), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", {
                style: _normalizeStyle({ width: _ctx.width + 'px' })
              }, [
                _createVNode(_component_ckeditor, {
                  editor: _ctx.editor,
                  modelValue: _ctx.pendingReply.body,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pendingReply.body) = $event)),
                  config: _ctx.editorConfig
                }, null, 8, ["editor", "modelValue", "config"])
              ], 4),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("small", null, [
                    _hoisted_9,
                    _createElementVNode("b", null, _toDisplayString(_ctx.email.replyFromAddress ?? _ctx.email.to ? _ctx.email.to![0] : ""), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "isClient",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pendingReply.isInternal) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.pendingReply.isInternal]
                    ]),
                    _hoisted_12
                  ]),
                  _createElementVNode("button", {
                    href: "#",
                    class: "btn btn-primary no-focus",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sendReply()), ["prevent"]))
                  }, " Send Reply ")
                ])
              ]),
              _createElementVNode("div", null, [
                (_ctx.isInitial || _ctx.isSaving)
                  ? (_openBlock(), _createElementBlock("form", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("input", {
                          type: "file",
                          multiple: "",
                          name: _ctx.uploadFieldName,
                          disabled: _ctx.isSaving,
                          onChange: _cache[4] || (_cache[4] = ($event: any) => {
                    _ctx.filesChange($event.target.name, $event.target.files);
                    _ctx.fileCount = $event.target.files.length;
                  }),
                          class: "input-file"
                        }, null, 40, _hoisted_15),
                        (_ctx.pendingReply.attachments.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Drag your file(s) here to begin or click to browse "))
                          : _createCommentVNode("", true),
                        (_ctx.pendingReply.attachments.length > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingReply.attachments, (attachment) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: attachment.name
                                }, [
                                  _createTextVNode(_toDisplayString(attachment.name), 1),
                                  _hoisted_18,
                                  _hoisted_19
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _ctx.replying]
            ])
          ], 512), [
            [_vShow, !_ctx.forwarding]
          ]),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  id: "to",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pendingEmail.to) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.pendingEmail.to]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  id: "from",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pendingEmail.from) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.pendingEmail.from]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  id: "subject",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pendingEmail.subject) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.pendingEmail.subject]
                ])
              ]),
              _createVNode(_component_ckeditor, {
                editor: _ctx.editor,
                modelValue: _ctx.pendingEmail.body,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pendingEmail.body) = $event)),
                config: _ctx.editorConfig
              }, null, 8, ["editor", "modelValue", "config"]),
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "isClient",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pendingEmail.isInternal) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.pendingEmail.isInternal]
                ]),
                _hoisted_28
              ]),
              _createElementVNode("button", {
                href: "#",
                class: "btn btn-primary no-focus float-right mt-2",
                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.forwardEmail()), ["prevent"]))
              }, " Forward "),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.isInitial || _ctx.isSaving)
                  ? (_openBlock(), _createElementBlock("form", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("input", {
                          type: "file",
                          multiple: "",
                          name: _ctx.uploadFieldName,
                          disabled: _ctx.isSaving,
                          onChange: _cache[11] || (_cache[11] = ($event: any) => {
                    _ctx.filesChange($event.target.name, $event.target.files);
                    _ctx.fileCount = $event.target.files.length;
                  }),
                          class: "input-file"
                        }, null, 40, _hoisted_32),
                        (_ctx.pendingEmail.attachments.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Drag your file(s) here to begin or click to browse "))
                          : _createCommentVNode("", true),
                        (_ctx.pendingEmail.attachments.length > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingEmail.attachments, (attachment) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: attachment.name
                                }, [
                                  _createTextVNode(_toDisplayString(attachment.name), 1),
                                  _hoisted_35,
                                  _hoisted_36
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _ctx.forwarding]
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.email.replies, (reply) => {
              return (_openBlock(), _createElementBlock("div", {
                key: reply.id,
                class: "col-12 border-top overflow-x-auto overflow-hidden"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_EmailHeader, {
                        from: reply.from,
                        to: reply.to,
                        dateCreated: reply.dateCreated,
                        isReply: true,
                        currentPage: _ctx.currentPage
                      }, null, 8, ["from", "to", "dateCreated", "currentPage"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      (reply.isInternal)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_40, " Internal only "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_EmailBody, {
                      onSizeChanged: _ctx.sizeChanged,
                      subject: reply.subject,
                      body: reply.body,
                      attachments: reply.attachments,
                      isReply: true
                    }, null, 8, ["onSizeChanged", "subject", "body", "attachments"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 512))
}